export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as homeTypeKey, initialState as homeTypeInitialState, State as HomeTypeState } from './reducer';

export {
  getData as homeTypeGetData,
  getError as homeTypeGetError,
  getLoading as homeTypeGetLoading,
  mapData as homeTypeMapData,
} from './selectors';
